var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-navbar"},[_vm._m(0),_c('AppMenu')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoBox"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/img/base/logo.png","alt":""}})])])
}]

export { render, staticRenderFns }